<template>
  <div :class="$style.base">
    <BaseCard>
      <BaseGrid container>
        <BaseGrid>
          <div :class="$style.title">
            <BaseText
              oneLine
              iconBefore="email"
              bold
            >
              {{ title }}
            </BaseText>
          </div>
        </BaseGrid>
        <BaseGrid
          :alignRight="$screen !== 's'"
          alignTop
        >
          <div :class="{ [$style.isSmall]: $screen === 's' }">
            <BaseLabel
              v-if="enabled"
              color="success"
              v-test="'enabledStateLabel'"
            >
              {{ $t('global.enabled') }}
            </BaseLabel>
            <BaseLabel
              v-else
              v-test="'disabledStateLabel'"
            >
              {{ $t('global.disabled') }}
            </BaseLabel>
          </div>
        </BaseGrid>
      </BaseGrid>
      <Flex direction="column">
        <BaseText>{{ description }}</BaseText>
        <BaseButton
          :routerLink="routerLink"
          fullWidth
          color="inverted"
          @click="clickTemplate"
          v-test="`enable-${routerLink.name}`"
        >
          {{ $t('global.settings') }}
        </BaseButton>
      </Flex>
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import type { LocationQueryRaw } from 'vue-router';
import { modal } from '@/helpers/ui';
import { useContactEmailVerification } from '../useContactEmailVerification';

const { contactEmailVerified, verifyContactEmail } =
  useContactEmailVerification();
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    enabled: boolean;
    routerLink: LocationQueryRaw;
    title?: string;
    description?: string;
  }>(),
  {
    title: '',
    description: '',
  },
);

const clickTemplate = () => {
  if (
    !contactEmailVerified &&
    props.routerLink.name !== 'rebook-reminder-dashboard'
  ) {
    modal('confirmation', {
      type: 'sendEmail',
      subMessage: t('email_templates.verification_modal.sub_message'),
      message: t('email_templates.verification_modal.message'),
    }).then(() => {
      verifyContactEmail();
    });
  }
};
</script>

<style
  lang="scss"
  module
>
.base {
  max-width: calc(400px - #{$spacing});
}

.isSmall {
  margin-bottom: $spacing * 0.5;
}

.title {
  margin-bottom: $spacing * 0.5;
}
</style>
